export enum MessageView {
  CASE = 'Case',
  ORGANIZATION = 'Organization',
  NEW = 'New'
}
